// extracted by mini-css-extract-plugin
export default {"privacy-terms-section":"styles_privacy-terms-section__sTFb2","card":"styles_card__Zk2Zo"};